import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toast.service';
import { Plan } from 'src/app/core/services/plan.service';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { Customer, CustomerService } from 'src/app/core/services/customer.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';


@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss'
})
export class CustomersComponent implements OnInit {

  customers: Customer[] = [];
  plans: Plan[] = [];
  loading = false;
  error = '';
  term: any;
  breadCrumbItems: Array<{}>;

  editForm!: UntypedFormGroup;
  modalRef!: NgbModalRef;
  editingCustomer: Customer | null = null;
  paymentType: any = ['COD', 'Online'];
  selectedPaymentMode: string = 'COD';
  @ViewChild('dt') table!: Table;

  constructor(
    private userService: CustomerService,
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private confirmModalService: ConfirmModalService
  ) {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Customers', active: true }];
  }

  ngOnInit(): void {
    this.editCustomer();
  }

  loadCustomers(event: LazyLoadEvent) {
    this.loading = true;
    this.cdr.detectChanges();
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      plan: this.selectedplan,
      startDate: startDate,
      endDate: endDate
    };
    this.userService.getCustomers(queryParams).subscribe({
      next: (res: any) => {
        this.customers = res?.data || [];
        this.totalRecords = res?.totalCount || 0;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  editCustomer() {
    this.editForm = this.fb.group({
      plan: [''],
      status: [''],
      mrr: [0],
      users: [0],
      documents: [0],
      planNote: [''],
      endDate: [],
      paymentMethod: ['COD']
    });
  }


  toggleUserStatus(customer: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;

    const newStatus: 'Active' | 'Inactive' = checked ? 'Active' : 'Inactive';

    input.checked = customer.status !== 'Inactive';

    if (customer.status === newStatus) {
      return;
    }

    const message =
      newStatus === 'Active'
        ? 'Are you sure you want to activate this customer?'
        : 'Are you sure you want to deactivate this customer?';

    this.confirmModalService.open(
      'Customer Status',
      message,
      () => {
        this.updateCustomerStatus(customer, newStatus);
      },
      newStatus === 'Active' ? 'Activate' : 'Deactivate',
      'Cancel'
    );
  }
  updateCustomerStatus(customer: any, newStatus: 'Active' | 'Inactive') {
    const payload: Partial<Customer> = {
      status: newStatus
    };

    this.userService.deactivateCustomer(customer._id, payload).subscribe({
      next: () => {
        this.loadCustomers({ first: 0, rows: this.rows });

        this.toastService.showToaster(
          'Success',
          `Customer ${newStatus === 'Active' ? 'activated' : 'deactivated'} successfully`,
          'success'
        );
      },
      error: () => { }
    });
  }

  viewInfo(customer: any) {
    this.router.navigate([`/customers/${customer?._id}`], {
    });
  }

  totalRecords = 0;
  rows = 10;
  searchText = '';
  selectedStatus: string = '';
  selectedplan: string = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Trial', value: 'Trial' }
  ];

  planOptions = [
    { label: 'All', value: '' },
    { label: 'Starter', value: 'Starter' },
    { label: 'Growth', value: 'Growth' },
    { label: 'Enterprise', value: 'Enterprise' }
  ];

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  filterChange(event: any) {
    this.selectedStatus = event.status;
    this.selectedplan = event.plan;
    this.searchText = event.search;
    this.rangeDates = event.dateRange
    this.table?.reset();
  }
}
